import { CFormGroup, CLabel, CTextarea } from "@coreui/react";
import { useWatch } from "react-hook-form";
import { BasicInput } from "src/components";

const EditVersionMetadata = ({ setValue, control }) => {
  const onChange = (e) => {
    const { name, value } = e.target;

    setValue(name, value, { shouldTouch: true });
  };

  const [label, description] = useWatch({
    control,
    name: ["label", "description"],
  });

  return (
    <div className="rounded bg-light p-3 mb-3">
      <CFormGroup>
        <CLabel>Label</CLabel>
        <BasicInput name="label" onChange={onChange} value={label} />
      </CFormGroup>
      <CFormGroup className="mt-4">
        <CLabel>Description</CLabel>
        <CTextarea
          name="description"
          onChange={onChange}
          rows={2}
          value={description}
        />
      </CFormGroup>
    </div>
  );
};

export default EditVersionMetadata;
